import { Component, input } from '@angular/core';
import { OnyxFlagsComponent } from '@onyx/angular';
import { DictionaryCode } from '../../../enums/dictionary-code';

@Component({
  selector: 'app-flags-cell',
  imports: [OnyxFlagsComponent],
  templateUrl: './flags-cell.component.html',
  styleUrl: './flags-cell.component.scss',
})
export class FlagsCellComponent {
  public readonly flags = input.required<string[]>();

  protected readonly DictionaryCode = DictionaryCode;
}
